import request from '@/utils/requestVr'
// 查询VR文件夹列表分页
export function fetchList(query) {
    return request({
        url: '/vr/folders/page',
        method: 'get',
        params: query,
    })
}
// 查询VR文件夹详细
export function getObj(id) {
    return request({
        url: '/vr/folders/detail?id=' + id,
        method: 'get',
    })
}
// 新增VR文件夹
export function addObj(data) {
    return request({
        url: '/vr/folders/add',
        method: 'post',
        data: data,
    })
}
// 分配文件
export function folderPage(data) {
    return request({
        url: '/vr/folders/categorized/folder',
        method: 'post',
        data: data,
    })
}
// 修改VR文件夹
export function putObj(data) {
    return request({
        url: '/vr/folders/edit',
        method: 'post',
        data: data,
    })
}
// 删除VR文件夹
export function delObj(data) {
    return request({
        url: '/vr/folders/delete',
        method: 'post',
        data: data,
    })
}
